import { useContext } from 'react';

import { IntlState } from './IntlProvider';

export const useIntlState = () => {
  return useContext(IntlState);
};
